module.exports = __webpack_public_path__ + "static/img/14000217.8297d800.png";